import React from 'react'
import { Image } from '@/components/ui'
import { useWebpExtension } from '@/utils/hooks/image'
import { messages } from './messages'
import './styles.scss'

export const FundingBannerLogos = () => {
  const imageExtension = useWebpExtension()

  return (
    <div className="fundingBannerLogos">
      <Image src={`loanProducts/brand/poleFinance.${imageExtension}`} isInStatic width={97} />
      <div className="fundingBannerInfo__registry">
        <Image src={`financing/inRegistry.${imageExtension}`} isInStatic width={32} />
        <h5>{messages.registry}</h5>
      </div>
    </div>
  )
}
